export default [
  {
    id: "plan_H6d4aayDJz8y2o",
    name: "free",
    price: 0,
    mostPopular: false,
    maxViews: 2000,
    features: [
      "Unlimited spotlights",
      "Basic analytics",
      "Up to 2,000 views/month",
    ],
  },
  {
    id: "plan_H9QgXf1bthqM9i",
    name: "starter",
    price: 9,
    mostPopular: false,
    maxViews: 25000,
    features: [
      "Unlimited spotlights",
      "Basic analytics",
      "Remove branding",
      "Teams",
      "Up to 25k views/month",
    ],
  },
  {
    id: "plan_H6d5nbbMYFdgUm",
    name: "premium",
    price: 29,
    mostPopular: true,
    maxViews: 250000,
    features: [
      "Unlimited spotlights",
      "Premium analytics",
      "Remove branding",
      "Teams",
      "Targeted Spotlights",
      "A/B Testing",
      "Up to 250k views/month",
    ],
  },
  {
    id: "plan_H6d5eoUqzQh4ER",
    name: "pro",
    price: 79,
    mostPopular: false,
    maxViews: 2000000,
    features: [
      "Everything in Premium +",
      "UTM Capabilities",
      "Multiple Sites",
      "Pro support",
      "Weekly reporting",
      "In-Context Spotlights (soon)",
      "Up to 2M views/month",
    ],
  },
];
